import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=081e3224"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/app/components/Breadcrumb.vue').default,BreadcrumbStructuredData: require('/app/components/BreadcrumbStructuredData.vue').default,Loading: require('/app/components/Loading.vue').default,ProductListItem: require('/app/components/ProductListItem.vue').default})
